export { agoShort, calendarShort, fullDate } from '@ui/member';

// Membership vocabulary: the date forms a membership surface reads (prose and
// table-width), plus how a member arrived. Kept out of the components (like
// lib/winbacks.ts) so the members table, the Plan/Renewal cells inside it, the
// profile header and the win-back board can't drift into different renderings of
// the same instant.
//
// The file keeps the name of the Revenue & retention page it was written for. That
// page is gone; what's left is the membership vocabulary that outlived it — the
// money helpers (per-currency text, month scales, the departure split) went with it.
import { parseTs } from './admin';

/** A membership date as plain text, e.g. "23 Dec 2026" (or "—"). Always through
 *  `parseTs`: these are UTC instants, and `new Date(iso)` reads a tz-less one as
 *  local time, which slides a renewal date across midnight. */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = parseTs(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

// The compact trio a dense table needs, as opposed to `fmtDate`'s prose form: a
// column two words wide can't spend eight characters on "23 Dec 2026". Shared so
// the members table's Active column and the RenewalCell inside it can't drift into
// two different shorthands for the same instant. All three go through `parseTs` for
// the reason `fmtDate` does.


/** How they arrived, in words. Skool's `attrComp` is a short code; anything we
 *  haven't seen is humanised rather than hidden, so a new value still reads. */
export function attributionLabel(code: string | null | undefined): string | null {
  if (!code) return null;
  const known: Record<string, string> = {
    invite: 'Invited by a member',
    affiliate: 'Affiliate referral',
    organic: 'Found it themselves',
  };
  return known[code] ?? code.charAt(0).toUpperCase() + code.slice(1).replace(/_/g, ' ');
}
